// FIREBASE CONFIGURATION
const FIREBASE_API_KEY = process.env.REACT_APP_API_KEY
const FIREBASE_MESSAGING_SENDER_ID = process.env.REACT_APP_MESSAGING_SENDER_ID
const FIREBASE_APP_ID = process.env.REACT_APP_APP_ID
const FIREBASE_MEASUREMENT_ID = process.env.REACT_APP_MEASUREMENT_ID

// EMAILJS CONFIGURATION
const EMAILJS_USER_ID = process.env.REACT_APP_EMAILJS_USER_ID
const EMAILJS_SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID
const EMAILJS_TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID

// MICROSOFT 365 OAUTH CONFIGURATION
const MICROSOFT_365_OAUTH_TENANT_ID =
  process.env.REACT_APP_MICROSOFT_365_OAUTH_TENANT_ID
const MICROSOFT_365_OAUTH_CLIENT_ID =
  process.env.REACT_APP_MICROSOFT_365_OAUTH_CLIENT_ID
const MICROSOFT_365_OAUTH_REDIRECT_URI =
  process.env.REACT_APP_MICROSOFT_365_OAUTH_REDIRECT_URI
const MICROSOFT_365_OAUTH_CLIENT_SECRET =
  process.env.REACT_APP_MICROSOFT_365_OAUTH_CLIENT_SECRET

const MICROSOFT_365_OAUTH_LOGIN_URI = `https://login.microsoftonline.com/${MICROSOFT_365_OAUTH_TENANT_ID}/oauth2/v2.0/authorize?client_id=${MICROSOFT_365_OAUTH_CLIENT_ID}&response_type=code&redirect_uri=${encodeURIComponent(
  MICROSOFT_365_OAUTH_REDIRECT_URI
)}&response_mode=query&scope=offline_access%20user.read&state=1234&prompt=select_account`

//  BE CONFIGURATION
const BE_DOMAIN = process.env.REACT_APP_BE_DOMAIN
const BE_TOKEN = process.env.BE_TOKEN

export {
  // FIREBASE CONFIGURATION
  FIREBASE_API_KEY,
  FIREBASE_MESSAGING_SENDER_ID,
  FIREBASE_APP_ID,
  FIREBASE_MEASUREMENT_ID,

  // EMAILJS CONFIGURATION
  EMAILJS_USER_ID,
  EMAILJS_SERVICE_ID,
  EMAILJS_TEMPLATE_ID,

  // MICROSOFT 365 OAUTH CONFIGURATION
  MICROSOFT_365_OAUTH_TENANT_ID,
  MICROSOFT_365_OAUTH_CLIENT_ID,
  MICROSOFT_365_OAUTH_REDIRECT_URI,
  MICROSOFT_365_OAUTH_CLIENT_SECRET,
  MICROSOFT_365_OAUTH_LOGIN_URI,
  //  BE CONFIGURATION
  BE_DOMAIN,
  BE_TOKEN,
}
